import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.api_url;
  }
}
